import { useRolesQuery } from './useRolesQuery';
import { useRoleUserCountsQuery } from './useRoleUserCountsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CreateRoleMutationParams {
  name: string;
  description?: string;
  permissions?: string[];
}

export const useCoreRoleCreateMutation = createMutationHook(
  'settings.teamPermissions.createRole',
  (params: CreateRoleMutationParams) => ({
    coreRoleCreate: {
      __args: {
        input: {
          name: params.name,
          description: params.description,
          permissions: params.permissions,
        },
      },
      id: true,
      name: true,
      description: true,
      permissions: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
  {
    invalidateQueries: [useRolesQuery, useRoleUserCountsQuery],
  },
);
